<style lang="scss" scoped>
@import '@/view/qwAuth/index.scss';
.bindAccount {
  text-align: center;
  .dialog {
    padding-bottom: 10px;
    .title {
      margin-top: 20px;
      font-size: 18px;
      color: #333;
    }
    .desc {
      color: #666;
      margin-top: 20px;
    }
    .footer {
      margin-top: 40px;
    }
  }
}
</style>
<template>
  <div class="bindAccount">
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="370px"
    >
      <div class="dialog">
        <img
          :src="require('@/assets/img/qwLogin/bindPhone/1.png')"
          alt=""
        >
        <div class="title">
          {{ title }}
        </div>
        <div class="desc">
          {{ desc }}
        </div>
      </div>
      <slot
        class="footer"
        name="footer"
      />
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'BindAccount',
  props: {
    title: {
      type: String,
      default: '登录失败'
    },
    desc: {
      type: String,
      default: '登录失败'
    }
  },
  data () {
    return {
      dialogVisible: true
    }
  },
  watch: {},
  mounted () {},
  methods: {}
}
</script>
